export default class ResponsiveVideo {
	static init() {
        const videos = document.querySelectorAll('video');
        videos.forEach(video => {
            new ResponsiveVideo(video);
        });
	}

	constructor(video) {
		this.video = video;
        this.width = this.video.getBoundingClientRect().width * window.devicePixelRatio; // Get width taking pixel density into account
		this.pickSource();
	}

	pickSource() {
		const self = this;
		this.matchedSource = null;
		this.prevDiff = 999999;

		// Loop over all video sources
		this.sourceCount = this.video.children.length;
		this.removedSources = 0;
		const removeSources = new Promise((resolve, reject) => {
			Array.from(this.video.children).forEach(source => {
				// Get source resolution (by provided by data attribute)
				let sourceWidth = source.dataset.sourcewidth;

				// Compare source resolution to video element width
				let currentDiff = sourceWidth - this.width;
				if (currentDiff <= 0) {
					currentDiff = currentDiff * -1;
				}
				if (currentDiff <= this.prevDiff) {
					this.matchedSource = source;
				}
				this.prevDiff = currentDiff;

				setTimeout(() => {
					source.remove();
					this.removedSources++;
					if (this.removedSources >= this.sourceCount) {
						resolve('Removed All Sources');
					}
				}, 0);
			});
		});

		removeSources.then(() => {
			if (this.video.dataset.lazyload) {
				this.video.dataset.src = this.matchedSource.dataset.src;
				this.video.dispatchEvent(new CustomEvent('video-ready'));
			} else {
				this.video.src = this.matchedSource.src;
			}

			if (this.video.dataset.autoplay) {
				this.video.addEventListener('loadeddata', e => {
					this.video.play();
				});
            }
            
            if (this.video.dataset.userplay) {
                this.video.parentElement.addEventListener('click', e => {
                    const isVideoPlaying = (this.video.currentTime > 0 && !this.video.paused && !this.video.ended && this.video.readyState > 2);
                    if (isVideoPlaying) {
                        this.video.parentElement.classList.remove('is-active');
                        this.video.pause();
                        this.video.currentTime = 0;
                    } else {
                        this.video.parentElement.classList.add('is-active');
                        this.video.play();
                    }
                });
                
                this.video.addEventListener('ended', e => {
                    this.video.currentTime = 0;
                    this.video.parentElement.classList.remove('is-active');
				});
            }
		});
	}

	playVideo() {
		this.video.play();
	}

	stopVideo() {
		this.video.pause();
	}
}
